module.exports = __webpack_public_path__ + "img/ai-compare-history-chevron-down.804a35ae.svg";